import { useState } from 'react';
import MaterialView from './MaterialView';
import MaterialEdit from './MaterialEdit';
import { Material } from 'components/IAP/hooks/useSafetyAnalysis';

const MaterialContainer: React.FC<{
  singleMaterial: Material;
  updateMaterial: (singleMaterial: Material) => void;
  deleteMaterial: (materialId: string) => void;
}> = ({ singleMaterial, updateMaterial, deleteMaterial }) => {
  const [isEditing, setIsEditing] = useState(false);
  return isEditing ? (
    <MaterialEdit
      singleMaterial={singleMaterial}
      setIsEditing={(choice) => setIsEditing(choice)}
      updateMaterial={updateMaterial}
    />
  ) : (
    <MaterialView
      singleMaterial={singleMaterial}
      setIsEditing={(choice) => setIsEditing(choice)}
      deleteMaterial={(materialId) => deleteMaterial(materialId)}
    />
  );
};

export default MaterialContainer;
